module.exports = __webpack_public_path__ + "img/ltksalealert-1x.8b18266.jpg";